import styled from "styled-components";
import { device } from "../breakpoints";

export const JourneyCard = styled.div<any>`
  width: ${(p) => (p.width ? p.width : "284px")};
  background-color: ${(p) => (p.bgColor ? p.bgColor : "#fff")};
  padding: 20px;
  border-radius: 16px;
  flex-shrink: 0;
  align-self: flex-start;
  display: flex;
  :nth-child(1) {
    margin-top: 150px;
  }
  :nth-child(2) {
    margin-top: 100px;
  }
  :nth-child(3) {
    margin-top: 50px;
  }
  @media ${device.mobile} {
    width: 180px;
    padding: 8px 12px;
    border-radius: 12px;
    align-self: flex-end;
    :nth-child(1) {
      margin-top: 16px;
      margin-right: 150px;
    }
    :nth-child(2) {
      margin-top: 16px;
      margin-right: 100px;
    }
    :nth-child(3) {
      margin-top: 16px;
      margin-right: 50px;
    }
  }
`;
export const JourneyCardIcon = styled.span`
  flex-shrink: 0;
  margin-right: 8px;
  padding-top: 7px;
  @media ${device.mobile} {
    padding-top: 2px;
  }
`;
export const JourneyCardDtl = styled.div`
  flex: 1;
`;
export const CardHeading = styled.h4`
  font-family: "Open Sans";
  font-size: 24px;
  line-height: 32px;
  color: #000;
  font-weight: 600;
  display: flex;
  align-items: center;
  @media ${device.mobile} {
    font-size: 14px;
    line-height: 19px;
  }
`;
export const CardDescription = styled.p`
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 20px;
  color: #000;
  margin: 16px 0;
  opacity: 0.8;
  @media ${device.mobile} {
    font-size: 12px;
    line-height: 16px;
    margin: 3px 0;
  }
`;
export const OverallText = styled.p`
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 20px;
  color: #000;
  margin-top: 16px;
  @media ${device.mobile} {
    font-size: 12px;
    line-height: 16px;
    margin-top: 5px;
  }
`;
export const Customers = styled.p`
  font-family: "Open Sans";
  font-size: 16px;
  line-height: 22px;
  color: #000;
  font-weight: 600;
  span {
    color: #2b825e;
  }
  @media ${device.mobile} {
    font-size: 12px;
    line-height: 16px;
  }
`;
